import { InteractionType } from "@/v2/entities/interaction-in-training/InteractionInTraining.model";
import * as Joi from "joi";
import { toast } from "sonner";

// this whole page should be deleted, we should not post window messages - we should use the context instead

export type SendMessageEvent = {
  type: "message" | "topic" | "reload";
  data?: SendMessageDataParams;
};

export type SendMessageDataParams = {
  message: string;
  ticketId?: string;
  conversationId?: string;

  pendingReview?: {
    id: number;
    interactionType: InteractionType;
  };
};

export const sendWindowPost = (event: SendMessageEvent) => {
  window.postMessage(event, "*");
};

export const validateSendMessageEvent = (
  event: unknown
): SendMessageEvent | null => {
  if (
    !event ||
    typeof event !== "object" ||
    !("type" in event) ||
    typeof event.type !== "string" ||
    !["message", "topic", "reload"].includes(event.type)
  ) {
    return null;
  }

  const schema = Joi.object({
    type: Joi.string().valid("message", "topic", "reload").required(),
    data: Joi.object({
      message: Joi.string().required(),
      ticketId: Joi.string().optional(),
      conversationId: Joi.string().optional(),
      pendingReview: Joi.object({
        id: Joi.number().required(),
        interactionType: Joi.string()
          .valid(InteractionType.TICKET, InteractionType.CONVERSATION)
          .required(),
      }).optional(),
    }),
  });

  const { error, value } = schema.validate(event);
  if (error) {
    toast.error(
      "We were unable to process your comment to the simulator! Please try pick a different comment."
    );
    return null;
  }

  return value;
};
